// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__l3qfW","name":"Header_name__3l643","birthday":"Header_birthday__1yEc5","skeleton":"Header_skeleton__3engv"};